import React, {useEffect, useState} from 'react';
import {View} from 'react-native';

import sy from '~/styles';
import {Text} from '~/components/controls';
import Format from '~/lib/format';

const LessorPersona = ({lessor, fallback = null, size = 40}) => {
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const retrieve = async () => {
      if (lessor) {
        const image_url = `https://bahnkick.blob.core.windows.net/company-logos/${lessor}.svg`;
        setImage(image_url);
        setLoading(true);
      } else {
        setLoading(false);
      }
    };

    retrieve();
  }, [lessor]);

  const height = size;
  const width = size;

  return image ? (
    <View
      style={[
        {
          visibility: loading ? 'hidden' : 'visible',
        },
      ]}>
      <img
        src={image}
        style={{width, height}}
        alt={lessor}
        onLoad={() => {
          setLoading(false);
        }}
        onError={() => {
          setImage(null);
          setLoading(false);
        }}
      />
    </View>
  ) : (
    fallback ?? (
      <View
        style={[
          sy['items-center'],
          sy['justify-center'],
          {
            backgroundColor: 'rgba(255, 108, 0, 0.5)',
            borderRadius: 50,
            width,
            height,
          },
        ]}>
        <Text
          style={[
            sy.uppercase,
            {
              fontWeight: '600',
              color: 'white',
              fontSize: Format.round(size / 2.5, 0),
              lineHeight: Format.round(size / 2.5, 0),
            },
          ]}>
          {lessor?.substring(0, 2)}
        </Text>
      </View>
    )
  );
};

export default LessorPersona;
